import { themeBackgrounds } from "@dana/MobiusOverrides/styles/colors";
import { shippingMethodStyles } from "@dana/Overrides/Widgets/OrderDetails/OrderDetailsShippingMethod";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { css } from "styled-components";

shippingMethodStyles.wrapper = mergeToNew(shippingMethodStyles.wrapper, {
    width: 12,
    css: css`
        display: flex;
        width: 100%;
        max-width: 100%;
        flex-direction: column;
        padding: 0px;
    `,
});

shippingMethodStyles.titleText = mergeToNew(shippingMethodStyles.titleText, {
    css: css`
        margin-bottom: 0px;
        background: ${themeBackgrounds.lightGray};
        padding: 4px;
        width: 100%;
        margin-bottom: 0px;
    `,
});

shippingMethodStyles.descritionWrapper = mergeToNew(shippingMethodStyles.descritionWrapper, {
    css: css`
        display: flex;
        flex-direction: column;
        padding: 4px;
    `,
});
